import { Link } from 'react-router-dom';
import SectionCard from '@/components/feature/SectionCard';
import MatchRow from '@/components/feature/MatchRow';
import NewsRow from '@/components/feature/NewsRow';
import { useSEO } from '@/hooks/useSEO';
import FeaturedCarousel from '@/pages/home/components/FeaturedCarousel';
import StandingsCard from '@/pages/home/components/StandingsCard';
import { allLeagues, allMatches, allNews } from '@/utils/data';

const statusOrder = { live: 0, upcoming: 1, finished: 2 };

export default function Home() {
  useSEO({
    title: '篮球比分 - 实时篮球赛况与数据更新平台',
    description:
      '篮球比分网站为篮球爱好者提供全面、及时的比赛比分和数据查询服务，涵盖多赛事和联赛，让用户随时掌握最新赛况。',
    keywords: '篮球比分,篮球赛况,篮球数据,篮球直播,篮球赛事,篮球得分,篮球排名',
  });

  const liveCount = allMatches.filter((m) => m.status === 'live').length;
  const todayMatches = [...allMatches]
    .sort((a, b) => statusOrder[a.status] - statusOrder[b.status])
    .slice(0, 9);
  const hotNews = allNews.slice(0, 6);

  return (
    <div className="animate-fade-up">
      <section className="border-b border-background-200 bg-background-100/50">
        <div className="px-4 md:px-6 py-5 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
          <div className="shrink-0">
            <h1 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">实时篮球赛况与数据</h1>
            <p className="mt-1 text-xs md:text-sm text-foreground-600">
              今日共 {allMatches.length} 场赛事 · <span className="text-primary-600 font-semibold">{liveCount} 场进行中</span> · 数据每 30 秒更新一次
            </p>
          </div>
          <div className="flex items-center gap-2 flex-wrap lg:ml-auto">
            {allLeagues.map((l) => (
              <Link
                key={l.id}
                to={`/category/${l.id}`}
                className="px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs md:text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {l.shortName}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <div className="px-4 md:px-6 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            <FeaturedCarousel />

            <SectionCard title="今日赛事快报" icon="ri-basketball-line" moreTo="/category/all" moreText="全部赛事">
              <div>
                {todayMatches.map((m) => (
                  <MatchRow key={m.id} match={m} />
                ))}
              </div>
            </SectionCard>
          </div>

          <aside className="space-y-6">
            <StandingsCard />

            <SectionCard title="新闻快讯" icon="ri-newspaper-line" moreTo="/news" moreText="更多新闻">
              <div>
                {hotNews.map((n) => (
                  <NewsRow key={n.id} news={n} />
                ))}
              </div>
            </SectionCard>
          </aside>
        </div>
      </div>
    </div>
  );
}